import axios from '../utils/axios';

export default function fetchCourseDetail(adminId, id) {
    return (
        axios.get('/admin/' + adminId + `/courses/course/${id}`)
    )
}